/**
 * Глобальные оповещения
 * @module Utils/notify
 * @requires quasar/Notify
 * */

import { Notify } from 'quasar'
import errorsMap, { DEFAULT_ERROR } from 'Constants/serverErrors'

/**
 * @constant NOTIFY_TIME - время уведомленяи по умолчнию в миллисекундах
 */
const NOTIFY_TIME = 500

export function parseServerErrors(message) {
  return errorsMap.find(el => el.value === message)?.label || message || DEFAULT_ERROR
}

/**
 * Глобальное оповещение
 * @function
 * @param {Object} data - Настройки оповещения
 * @param {String} data.type - Тип (info|warning|negative|positive)
 * @param {String} data.time - Время отображения в мск
 * @param {String} data.text - Текст
 * */
export function notify(data) {
  Notify.create({
    position: 'top',
    type: data.type || 'info',
    timeout: data.time || NOTIFY_TIME,
    textColor: 'white',
    actions: [{
      icon: 'close',
      color: 'white'
    }],
    message: data.text
  })
}

/**
 * Негативное глобальное оповещение
 * @function
 * @param {String} message - Текст
 * */
export function notifyError(message) {
  notify({
    type: 'negative',
    text: parseServerErrors(message),
    time: 3000
  })
}

/**
 * Позитивное глобальное оповещение
 * @function
 * @param {String} message - Текст
 * */
export function notifySuccess(message) {
  notify({
    type: 'positive',
    text: message,
    time: 3000
  })
}

export default {
  notify,
  notifyError,
  notifySuccess
}
